export default __webpack_public_path__ + "static/unboxing-ddb20677a5df2f4c0bf37d26046c61f5.png";